import { withWordpressLanguage } from 'wordpress/utils'
import { getRecentNews } from 'dashboard/actions'
import { loadOnMount } from 'shared/hoc'

import { newsSelector } from '../selectors'
import './News.scss'

const NewsArticle = ({ article: { title, excerpt, slug } }) => {
    const url = `news/uncategorized/${slug}`

    return (
        <div className="news-article">
            <Link to={url} title={title}>
                <h2>{title}</h2>
            </Link>
            <div dangerouslySetInnerHTML={{ __html: excerpt }} />
            <p className="read-more">
                <Link to={url} title={title}>
                    <T>news.label.read.more</T> <i className="icon-right" />
                </Link>
            </p>
        </div>
    )
}

const News = ({ news }) => (
    <div className="news">
        {news.map((article, i) => (
            <NewsArticle article={article} key={i} />
        ))}
    </div>
)

export default compose(
    withWordpressLanguage,
    connect(
        createStructuredSelector({
            news: newsSelector,
        }),
        { getRecentNews }
    ),
    loadOnMount('getRecentNews')
)(News)
